import { Box, Button, Divider, FormControlLabel, Radio, Typography } from "@mui/material"
import VertcialCenterGridItem from "./VertcialCenterGridItem"
import LicenseCard from "./LicenseCard"
import { useTheme } from "@mui/styles"
import BuildingGraphic from "./building.svg?react"
import { pageNames } from "plugins/Paywall/paywall-constants"

const SubscriptionCard = ({ setPage }) => {
    const theme = useTheme()
    const subscribeColor = theme.palette.license.subscription

    return (
        <VertcialCenterGridItem>
            <label>
                <FormControlLabel
                    value="subscription"
                    label="Subscription option"
                    sx={{ m: 0, display: "none" }}
                    control={<Radio />}
                />
                <LicenseCard borderColor={subscribeColor}>
                    <Box
                        sx={{
                            alignItems: "flex-start",
                            display: "flex",
                            flexDirection: "column",
                            gap: "16px",
                        }}
                        data-cy="subscription-card"
                    >
                        <Typography
                            component="h1"
                            variant="h4"
                            sx={{
                                position: "absolute",
                                width: 1,
                                height: 1,
                                overflow: "hidden",
                                clip: "rect(0 0 0 0)",
                                whiteSpace: "nowrap",
                                border: 0,
                                padding: 0,
                                margin: 0,
                            }}
                        >
                            SFG20 Subscription Options
                        </Typography>

                        <Typography component="h2" variant="h4">
                            SFG20 Facilities-iQ Subscription
                        </Typography>

                        <BuildingGraphic />

                        <Typography variant="body2">
                            This subscription gives you full access to SFG20 Facilities iQ
                        </Typography>

                        <Divider flexItem sx={{ borderStyle: "dashed" }} />

                        <Typography component="h3" variant="subtitle1">
                            Features:
                        </Typography>

                        <Typography variant="body2">
                            Access to SFG20 Core schedule library with optional additional Specialist Sets
                        </Typography>
                        <Typography variant="body2">
                            Manage Maintenance Regimes making sure you&apos;re not over maintaining assets or falling
                            out of conformity.
                        </Typography>
                        <Typography variant="body2">Multiple licences and licence type.</Typography>
                        <Typography variant="body2">
                            Create share links to allow collaboration with internal and external partners.
                        </Typography>
                        <Typography variant="body2">
                            Keep informed of SFG20 schedule updates and how this affects you.
                        </Typography>
                        <Typography variant="body2">Integrates into 3rd party software such as CAFM</Typography>

                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => setPage(pageNames.contact)}
                            data-cy="contact-subscription"
                            sx={{
                                flex: "1 1 0",
                                minWidth: 150,
                                whiteSpace: "nowrap",
                                mt: "auto",
                            }}
                        >
                            Contact SFG20
                        </Button>
                    </Box>
                </LicenseCard>
            </label>
        </VertcialCenterGridItem>
    )
}

export default SubscriptionCard
